var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobile = function SvgMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 22,
    fill: "#C8C8C8",
    fillRule: "evenodd",
    viewBox: "0 0 14 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 19.01c0 .54.452.99 1.009.99h7.982c.558 0 1.009-.447 1.009-.99V2.99c0-.54-.452-.99-1.009-.99H3.01C2.45 2 2 2.447 2 2.99zM3.009 1h7.982C12.101 1 13 1.898 13 2.99v16.02c0 1.099-.902 1.99-2.009 1.99H3.01A2.004 2.004 0 0 1 1 19.01V2.99C1 1.892 1.902 1 3.009 1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 18a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0m-2 0a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0M3 4l1-1v13l-1-1h8l-1 1V3l1 1zm8-1v13H3V3z"
  })));
};
export default SvgMobile;